import React, { useEffect, useState } from 'react';

import { getAccessToken } from 'utils/access-token';
import { getAccountDetails } from 'utils/account-details';

import AuthorizationController from 'auth/AuthorizationController';

import { InitializationLoadingPlaceholder } from 'components/shared/InitializationLoadingPlaceholder';

// When already logged in the token is not instantly available
// We wait and check 0.1 second later for it to be available
const waitForUserInfo = (setToken) => {
  const intervalId = setInterval(() => {
    const token = getAccessToken();
    if (token) {
      clearInterval(intervalId);
      setToken(token);
    }
  }, 100);
};

const waitForAccountDetails = (setAccountDetails) => {
  const intervalId = setInterval(() => {
    const details = getAccountDetails();
    if (details) {
      clearInterval(intervalId);
      setAccountDetails(details);
    }
  }, 100);
};

const AuthenticationController = () => {
  const [token, setToken] = useState(null);
  const [accountDetails, setAccountDetails] = useState(null);

  useEffect(() => {
    const delay = setTimeout(() => {
      waitForUserInfo(setToken);
      waitForAccountDetails(setAccountDetails);
    }, 300);

    return () => clearTimeout(delay);
  }, []);

  if (token && accountDetails?.accountStatus) {
    return <AuthorizationController accountDetails={accountDetails} />;
  }
  return <InitializationLoadingPlaceholder />;
};

export default AuthenticationController;
